const SHORT_REQUEST_NUMBER_FIELDS = [
  "customerRequestNumber",
  "shortRequestNumber",
  "publicRequestNumber",
  "customer_request_number",
  "short_request_number",
  "public_request_number",
  "requestNumber",
  "requestno",
  "request_number",
  "caseno",
  "caseNo",
  "case_number",
];

const normalizeReference = (value) => String(value ?? "").trim();

export function isInternalCaseNumber(value) {
  return normalizeReference(value).includes("/");
}

export function deriveShortRequestNumber(value) {
  const parts = normalizeReference(value)
    .toUpperCase()
    .split("/")
    .map((part) => part.trim());

  if (parts.length < 5) return "";

  const sourcePrefix = (parts[0].match(/[A-Z]/) || [""])[0];
  const period = parts[3].replace(/\D/g, "");
  const sequence = parts[4].replace(/\D/g, "").replace(/^0+/, "");

  if (!sourcePrefix || period.length !== 4 || !sequence) return "";

  return `${sourcePrefix}${period}${sequence}`;
}

export function getCustomerRequestNumber(source) {
  if (!source || typeof source !== "object") return "";

  for (const field of SHORT_REQUEST_NUMBER_FIELDS) {
    const value = normalizeReference(source[field]);
    if (value && !isInternalCaseNumber(value)) return value;
  }

  for (const field of ["caseno", "caseNo", "case_number", "requestno", "requestNumber"]) {
    const derivedReference = deriveShortRequestNumber(source[field]);
    if (derivedReference) return derivedReference;
  }

  return "";
}
